import links from "utils/links"

export default [
  {
    name: "Log In",
    link: links.login,
  },
  // {
  //   name: "Templates",
  //   link: links.templates,
  // },
  {
    name: "About",
    link: links.about,
  },
  {
    name: "Careers",
    link: links.careers,
  },
  {
    name: "Contact",
    link: links.contact,
  },
]
